import {
  Button,
  Flex,
  Icon,
  IconButton,
  useColorMode,
  useMediaQuery,
  useDisclosure,
  Drawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { FaSignOutAlt } from "react-icons/fa";
import { FiMenu, FiMoon, FiSun, FiLock, FiUploadCloud } from "react-icons/fi";
import Link from "next/link";
import { useRouter } from "next/router";
import { useAuth } from "@/utils/auth";
export function Header() {
  const { user, signOutfunc } = useAuth();
  const { locale, push, asPath, reload } = useRouter();
  const nextLocale = locale === "en" ? "ar" : "en";
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isDesktop] = useMediaQuery("(min-width: 48em)");
  return (
    <header>
      <Flex
        py={2}
        px={[2, 4]}
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex>
          <Link href="/" passHref prefetch={false}>
            <Icon width="30" height="7" viewBox="0 0 60 14" color="red.500">
              {colorMode === "dark" ? (
                <path
                  d="M0.36 13.5C0.36 13.8 0.56 14 0.86 14H6.2C10.2 14 12.26 12.18 12.38 8.54C12.4 8.36 12.4 8.14 12.4 7.88V6.16C12.4 5.9 12.4 5.68 12.38 5.5C12.3 1.76 9.76 0.0599995 6.1 0.0599995H2.1C1.14 0.0599995 0.36 0.839999 0.36 1.8V13.5ZM4.72 11.02C4.54 11.02 4.38 10.96 4.28 10.84C4.16 10.72 4.1 10.58 4.1 10.4V4.08C4.1 3.5 3.56 3.04 3 3.04H6C7.68 3.04 8.54 3.88 8.58 5.54C8.6 5.72 8.6 5.94 8.62 6.18V7.84C8.6 8.1 8.6 8.32 8.58 8.5C8.54 10.18 7.82 11.02 6.1 11.02H4.72ZM26.515 13.84C26.595 13.74 26.635 13.64 26.635 13.54C26.635 13.48 26.615 13.4 26.575 13.32L24.075 8.78C24.055 8.72 24.035 8.66 24.035 8.56C24.035 8.46 24.095 8.38 24.195 8.3C25.675 7.5 26.315 6.24 26.315 4.58C26.315 1.32 23.775 0.0199988 20.735 0.0199988H16.495C15.535 0.0199988 14.755 0.799999 14.755 1.76V13.46C14.755 13.76 14.955 13.96 15.255 13.96H17.975C18.135 13.96 18.255 13.92 18.355 13.82C18.455 13.74 18.495 13.62 18.495 13.46V10.16C18.495 9.56 17.975 9.1 17.395 9.1H20.035C20.275 9.1 20.455 9.2 20.575 9.42L22.595 13.42C22.755 13.78 23.035 13.96 23.415 13.96H26.215C26.335 13.96 26.435 13.92 26.515 13.84ZM22.455 4.56C22.455 5.66 21.775 6.18 20.715 6.18H18.975C18.635 6.18 18.355 5.9 18.355 5.56V3.96C18.355 3.38 17.855 2.88 17.275 2.88H20.715C21.255 2.88 21.675 3.02 21.995 3.3C22.295 3.6 22.455 4.02 22.455 4.56ZM28.6413 13.5C28.6413 13.8 28.8413 14 29.1413 14H31.9813C32.1413 14 32.2613 13.96 32.3413 13.86C32.4413 13.76 32.4813 13.64 32.4813 13.5V0.559999C32.4813 0.42 32.4413 0.299999 32.3413 0.199999C32.2613 0.099999 32.1413 0.0599995 31.9813 0.0599995H30.3813C29.4013 0.0599995 28.6413 0.819999 28.6413 1.8V13.5ZM44.3233 -9.53674e-07C44.1433 -9.53674e-07 43.9633 0.0599995 43.8233 0.159999C43.7033 0.259999 43.6233 0.379999 43.5833 0.539999L40.7633 9.22L38.1433 0.539999C38.1033 0.4 38.0233 0.279999 37.9033 0.159999C37.7633 0.0599995 37.5833 -9.53674e-07 37.4033 -9.53674e-07H34.8033C34.7033 -9.53674e-07 34.5833 0.0399997 34.4833 0.12C34.4033 0.22 34.3633 0.32 34.3633 0.42L34.4033 0.6L38.4233 13.34C38.4833 13.52 38.5833 13.66 38.7233 13.76C38.8433 13.88 39.0233 13.94 39.2633 13.94H42.4633C42.7033 13.94 42.8833 13.88 43.0233 13.76C43.1633 13.66 43.2433 13.52 43.2833 13.34L47.3233 0.6C47.3433 0.559999 47.3433 0.5 47.3433 0.42C47.3433 0.32 47.3033 0.22 47.2233 0.12C47.1433 0.0399997 47.0433 -9.53674e-07 46.9233 -9.53674e-07H44.3233ZM48.798 13.46C48.798 13.76 48.998 13.96 49.298 13.96H58.858C59.138 13.96 59.378 13.74 59.378 13.46V11.5C59.378 11.18 59.178 10.98 58.858 10.98H53.018C52.838 10.98 52.678 10.92 52.578 10.78C52.458 10.64 52.398 10.5 52.398 10.36V9.42C52.398 8.84 51.858 8.38 51.298 8.38H57.358C57.698 8.38 57.878 8.2 57.878 7.86V6.06C57.878 5.72 57.698 5.54 57.358 5.54H53.018C52.678 5.54 52.398 5.28 52.398 4.92V4.08C52.398 3.48 51.898 3 51.298 3H58.698C58.838 3 58.958 2.96 59.058 2.86C59.158 2.78 59.218 2.66 59.218 2.52V0.539999C59.218 0.279999 58.958 0.0199988 58.698 0.0199988H50.538C49.558 0.0199988 48.798 0.78 48.798 1.76V13.46Z"
                  fill="white"
                />
              ) : (
                <path
                  d="M0.36 13.5C0.36 13.8 0.56 14 0.86 14H6.2C10.2 14 12.26 12.18 12.38 8.54C12.4 8.36 12.4 8.14 12.4 7.88V6.16C12.4 5.9 12.4 5.68 12.38 5.5C12.3 1.76 9.76 0.0599995 6.1 0.0599995H2.1C1.14 0.0599995 0.36 0.839999 0.36 1.8V13.5ZM4.72 11.02C4.54 11.02 4.38 10.96 4.28 10.84C4.16 10.72 4.1 10.58 4.1 10.4V4.08C4.1 3.5 3.56 3.04 3 3.04H6C7.68 3.04 8.54 3.88 8.58 5.54C8.6 5.72 8.6 5.94 8.62 6.18V7.84C8.6 8.1 8.6 8.32 8.58 8.5C8.54 10.18 7.82 11.02 6.1 11.02H4.72ZM26.515 13.84C26.595 13.74 26.635 13.64 26.635 13.54C26.635 13.48 26.615 13.4 26.575 13.32L24.075 8.78C24.055 8.72 24.035 8.66 24.035 8.56C24.035 8.46 24.095 8.38 24.195 8.3C25.675 7.5 26.315 6.24 26.315 4.58C26.315 1.32 23.775 0.0199988 20.735 0.0199988H16.495C15.535 0.0199988 14.755 0.799999 14.755 1.76V13.46C14.755 13.76 14.955 13.96 15.255 13.96H17.975C18.135 13.96 18.255 13.92 18.355 13.82C18.455 13.74 18.495 13.62 18.495 13.46V10.16C18.495 9.56 17.975 9.1 17.395 9.1H20.035C20.275 9.1 20.455 9.2 20.575 9.42L22.595 13.42C22.755 13.78 23.035 13.96 23.415 13.96H26.215C26.335 13.96 26.435 13.92 26.515 13.84ZM22.455 4.56C22.455 5.66 21.775 6.18 20.715 6.18H18.975C18.635 6.18 18.355 5.9 18.355 5.56V3.96C18.355 3.38 17.855 2.88 17.275 2.88H20.715C21.255 2.88 21.675 3.02 21.995 3.3C22.295 3.6 22.455 4.02 22.455 4.56ZM28.6413 13.5C28.6413 13.8 28.8413 14 29.1413 14H31.9813C32.1413 14 32.2613 13.96 32.3413 13.86C32.4413 13.76 32.4813 13.64 32.4813 13.5V0.559999C32.4813 0.42 32.4413 0.299999 32.3413 0.199999C32.2613 0.099999 32.1413 0.0599995 31.9813 0.0599995H30.3813C29.4013 0.0599995 28.6413 0.819999 28.6413 1.8V13.5ZM44.3233 -9.53674e-07C44.1433 -9.53674e-07 43.9633 0.0599995 43.8233 0.159999C43.7033 0.259999 43.6233 0.379999 43.5833 0.539999L40.7633 9.22L38.1433 0.539999C38.1033 0.4 38.0233 0.279999 37.9033 0.159999C37.7633 0.0599995 37.5833 -9.53674e-07 37.4033 -9.53674e-07H34.8033C34.7033 -9.53674e-07 34.5833 0.0399997 34.4833 0.12C34.4033 0.22 34.3633 0.32 34.3633 0.42L34.4033 0.6L38.4233 13.34C38.4833 13.52 38.5833 13.66 38.7233 13.76C38.8433 13.88 39.0233 13.94 39.2633 13.94H42.4633C42.7033 13.94 42.8833 13.88 43.0233 13.76C43.1633 13.66 43.2433 13.52 43.2833 13.34L47.3233 0.6C47.3433 0.559999 47.3433 0.5 47.3433 0.42C47.3433 0.32 47.3033 0.22 47.2233 0.12C47.1433 0.0399997 47.0433 -9.53674e-07 46.9233 -9.53674e-07H44.3233ZM48.798 13.46C48.798 13.76 48.998 13.96 49.298 13.96H58.858C59.138 13.96 59.378 13.74 59.378 13.46V11.5C59.378 11.18 59.178 10.98 58.858 10.98H53.018C52.838 10.98 52.678 10.92 52.578 10.78C52.458 10.64 52.398 10.5 52.398 10.36V9.42C52.398 8.84 51.858 8.38 51.298 8.38H57.358C57.698 8.38 57.878 8.2 57.878 7.86V6.06C57.878 5.72 57.698 5.54 57.358 5.54H53.018C52.678 5.54 52.398 5.28 52.398 4.92V4.08C52.398 3.48 51.898 3 51.298 3H58.698C58.838 3 58.958 2.96 59.058 2.86C59.158 2.78 59.218 2.66 59.218 2.52V0.539999C59.218 0.279999 58.958 0.0199988 58.698 0.0199988H50.538C49.558 0.0199988 48.798 0.78 48.798 1.76V13.46Z"
                  fill="#333333"
                />
              )}
            </Icon>
          </Link>
        </Flex>
        {isDesktop ? (
          <Flex>
            <Link href={asPath} locale={nextLocale} passHref prefetch={true}>
              <Button
                aria-label="Toggle Lang"
                as="button"
                variant="ghost"
                align="center"
                mx={2}
                size={["md"]}
              >
                {locale === "en" ? "🇸🇦" : "🇺🇸"}
              </Button>
            </Link>
            <IconButton
              aria-label="Toggle Mode"
              as="button"
              variant="ghost"
              onClick={toggleColorMode}
              align="center"
              icon={colorMode === "dark" ? <FiMoon /> : <FiSun />}
              mx={2}
              size={["md"]}
            />
            <Link href={"/Upload/"} passHref prefetch={false}>
              <IconButton
                as="button"
                icon={<FiUploadCloud />}
                colorScheme="blue"
                variant="ghost"
                role="presentation"
                // fontSize={["sm", "md", "lg"]}
                aria-label="Upload"
                mx={2}
                size={["md"]}
              />
            </Link>
            {user ? (
              <IconButton
                aria-label="Sign out"
                as="button"
                onClick={signOutfunc}
                icon={<FaSignOutAlt />}
                colorScheme="red"
                variant="ghost"
              />
            ) : (
              <Link href={`/SignIn?url=${asPath}`} passHref prefetch={false}>
                <Button
                  as="button"
                  colorScheme="blue"
                  variant="ghost"
                  leftIcon={<Icon as={FiLock} />}
                  role="presentation"
                  fontSize={["sm", "md", "lg"]}
                  aria-label="Joinus"
                >
                  <strong>Join</strong>
                </Button>
              </Link>
            )}
          </Flex>
        ) : (
          <IconButton
            aria-label="Toggle Mode"
            as="button"
            variant="ghost"
            onClick={onOpen}
            align="center"
            icon={<FiMenu />}
            mx={2}
            size={["md"]}
          />
        )}
        <Drawer onClose={onClose} isOpen={isOpen} size="full" placement="top">
          <DrawerOverlay>
            <DrawerContent>
              <DrawerCloseButton />
              <DrawerHeader>Axenda Drive</DrawerHeader>
              <DrawerBody>
                <Flex flexDirection="column" mt="32">
                  <Link
                    href={asPath}
                    locale={nextLocale}
                    passHref
                    prefetch={false}
                  >
                    <Button
                      aria-label="Toggle Lang"
                      as="button"
                      variant="ghost"
                      align="center"
                      mx={2}
                      size={["md"]}
                    >
                      {locale === "en" ? "🇸🇦" : "🇺🇸"}
                    </Button>
                  </Link>
                  <IconButton
                    aria-label="Toggle Mode"
                    as="button"
                    onClick={toggleColorMode}
                    align="center"
                    icon={colorMode === "dark" ? <FiMoon /> : <FiSun />}
                    my={2}
                    variant="ghost"
                    size={["md"]}
                  />
                  <Link href="/Upload/" passHref prefetch={false}>
                    <Button
                      as="button"
                      leftIcon={<Icon as={FiUploadCloud} />}
                      colorScheme="blue"
                      variant="ghost"
                      role="presentation"
                      fontSize={["sm", "md", "lg"]}
                      aria-label="Upload"
                      size={["md"]}
                    >
                      <strong>Upload</strong>
                    </Button>
                  </Link>
                  {user ? (
                    <IconButton
                      variant="ghost"
                      aria-label="Sign out"
                      as="button"
                      onClick={signOutfunc}
                      icon={<FaSignOutAlt />}
                      colorScheme="red"
                      my={2}
                    />
                  ) : (
                    <Link
                      href={`/SignIn?url=${asPath}`}
                      passHref
                      prefetch={false}
                    >
                      <Button
                        as="button"
                        colorScheme="blue"
                        variant="ghost"
                        leftIcon={<Icon as={FiLock} />}
                        role="presentation"
                        fontSize={["sm", "md", "lg"]}
                        aria-label="Joinus"
                        my={2}
                      >
                        <strong>Join</strong>
                      </Button>
                    </Link>
                  )}
                </Flex>
              </DrawerBody>
            </DrawerContent>
          </DrawerOverlay>
        </Drawer>
      </Flex>
    </header>
  );
}
